// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBCol, MDBContainer, MDBRow } from 'mdbreact';

const SectionContainerOneCol = ({ children }) => (
  <div className="p-0">
    {
      children.map((child, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="h-paddings-half">
          <div>
            {child}
          </div>
        </div>
      ))
    }
  </div>
);

export default SectionContainerOneCol;
